import { v4 as uuid } from 'uuid';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import LinkData from '../../../models/LinkData';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

class BlockCarouselItemData {
  id: string;
  image: BlockComponentImage;
  link?: LinkData;
  text?: BlockComponentText;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockCarouselItemData {
  export function make(image: string, link?: LinkData, text?: string): BlockCarouselItemData {
    return {
      id: uuid(),
      image: BlockComponentImage.make(image),
      link,
      text: BlockComponentText.make(text),
    };
  }

  export function getDefault(src = ''): BlockCarouselItemData {
    return make(
      src,
      undefined,
      '',
    );
  }
}

export default BlockCarouselItemData;
